import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteProjectImageAnnotation = (token: string) => (
  projectId: number,
  imageId: number,
  annotationUuid: string
) =>
  deleteTemplateFn(
    token,
    uri.projectImageAnnotationById(projectId, imageId, annotationUuid)
  );
